import classNames from 'classnames';
import React from 'react';
import type { DayPickerProps } from 'react-day-picker';
import { DayPicker as ReactDayPicker } from 'react-day-picker';
import styles from './DayPicker.module.scss';

const DayPicker = (props: DayPickerProps) => {
  return (
    <ReactDayPicker
      {...props}
      className={classNames(styles.dayPicker, props.className)}
    />
  );
};

export default DayPicker;
